import { render } from "./bindSpaceView.vue?vue&type=template&id=7f01f3c2&scoped=true&ts=true"
import script from "./bindSpaceView.vue?vue&type=script&lang=ts"
export * from "./bindSpaceView.vue?vue&type=script&lang=ts"

import "./bindSpaceView.vue?vue&type=style&index=0&id=7f01f3c2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f01f3c2"]])

export default __exports__